/** `/c/$companyId/purchases/payments/new?supplier&bill` — a new payment, created on its first save. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CODES } from "../ledger/books";
import { PaymentPage } from "../payments/page/PaymentPage";
import { CodeGate } from "../shell/CodeGate";

const search = z.object({
  supplier: z.string().uuid().optional().catch(undefined),
  /** The bill being paid (its currency is the payment's). */
  bill: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/payments/new")({
  validateSearch: (raw) => search.parse(raw),
  component: NewPaymentRoute,
});

function NewPaymentRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { supplier, bill } = Route.useSearch();
  return (
    <CodeGate companyId={companyId} codes={[CODES.paymentPrepare]}>
      <PaymentPage companyId={companyId} supplier={supplier} bill={bill} />
    </CodeGate>
  );
}
